<template>
    <div v-if="projectMessages">
        <detail-project-name :project_id="this.project_id"
                             :project_name="projectMessages.projectName"></detail-project-name>
        <div class="logo-cont">
            <project-logo :project_id="this.project_id"></project-logo>
            <detail-project-info :project_id="this.project_id"></detail-project-info>
        </div>

        <table class="table">
            <tbody>
            <tr>
                <th v-for="projectColumn in projectMessages.columns">{{projectColumn}}</th>
            </tr>
            <template v-if="getProjectItems">
                <project-detail-item v-for="projectItem in getProjectItems" :projectItem="projectItem" :columns="projectMessages.columns"
                                     :key="projectItem.id" :project_id="project_id" :selfSelect="selecte"
                                     :photoSelect="photoSelect"></project-detail-item>
            </template>
            <template v-else>
                <div v-if="projectMessages">{{projectMessages.noProducts}}</div>
            </template>
            </tbody>
        </table>
        <div class="bottom-part">
            <div class="left-select">
                <div v-if="projectNotesSchema" class="name">
                    <ui-input-field :field="projectNotesSchema.project_notes1_field"
                                    @enter="changeProjectNotes1"
                                    @blur="changeProjectNotes1"
                                    v-model="projectNotes1"></ui-input-field>
                    <ui-input-field v-if="projectNotesSchema.project_notes1_field.value"
                                    :field="projectNotesSchema.project_notes2_field"
                                    @enter="changeProjectNotes2"
                                    @blur="changeProjectNotes2"
                                    v-model="projectNotes2"></ui-input-field>
                    <ui-input-field v-if="projectNotesSchema.project_notes2_field.value"
                                    :field="projectNotesSchema.project_notes3_field"
                                    @enter="changeProjectNotes3"
                                    @blur="changeProjectNotes3"
                                    v-model="projectNotes3"></ui-input-field>
                </div>
                <div v-if="projectMessages" class="sel-wrap">
                    <select v-model="selecte" v-on:change="changeSelfSelect()" class="project-select">
                      <option v-for="(item, key) in projectMessages.select_self" v-bind:value="item.value">{{item.text}}</option>
                    </select>
                    <select data-styler v-on:change="changePhotoSelect()" class="project-select">
                        <option v-for="item in projectMessages.select_photo">{{item}}</option>
                    </select>
                </div>
                <div class="btn-cont">
                    <a :href="projectMessages.saveProjectLink" class="btn-std btn">
                        {{projectMessages.saveProject}}
                    </a>
                    <a :href="projectMessages.toProjectCreateLink" class="btn-gray btn">
                        {{projectMessages.toProjectCreate}}
                    </a>
                    <a
                        :href="projectMessages.deleteProjectLink"
                        class="btn-std btn"
                        @click="deleteProject(projectMessages.deleteProjectLink)"
                    >
                        {{projectMessages.deleteProject}}
                    </a>
                </div>
            </div>
            <div :class="discountOpen ? 'discount show' : 'discount'">
                <template v-if="getProjectItems">
                  <div>

                      <div class="table-total" v-if="getProjectTotalSum.retailSum || getProjectTotalSum.retailAznSum">
                          <div class="m-8 sum" v-html="getProjectTotalSum.retailSum"></div>
                          <div class="m-8 sum" v-html="getProjectTotalSum.optSum"></div>
                          <div class="m-8 sum" v-html="getProjectTotalSum.retailAznSum"></div>
                          <div v-if="getProjectTotalSum.viewProfit > 0 && getProjectTotalSum.viewOptSum && projectMessages.countSale == ''" class="m-11" v-html="getProjectTotalSum.profit"></div>
                          <div v-if="getProjectTotalSum.discountSum" class="m-8 sum" v-html="getProjectTotalSum.discountSum"></div>
                          <div v-if="" class="m-11" v-html="getProjectTotalSum.nds"></div>
                          <div v-if="" class="m-11" v-html="getProjectTotalSum.SumNDS"></div>
                    </div>
                    <div class="table-total" v-else>
                        <div v-if="getProjectTotalSum.discountSum" class="m-8 sum" v-html="getProjectTotalSum.discountSum"></div>
                        <div class="m-8 sum" v-html="getProjectTotalSum.retailSum"></div>
                        <div class="m-8 sum" v-html="getProjectTotalSum.optSum"></div>
                        <div class="m-8 sum" v-html="getProjectTotalSum.retailAznSum"></div>
                      <div  v-if="" class="m-11" v-html="getProjectTotalSum.nds"></div>
                      <div v-if="projectTransferSchema.project_transfer_field.checked" class="m-11" v-html="getProjectTotalSum.SumNDS"></div>
                    </div>
                    <div v-if="projectDiscountSchema && projectMessages.countSale != ''" class="proc-dis">
                        <ui-input-field :field="projectDiscountSchema.project_discount_field"
                                        @enter="changeProjectDiscount"
                                        @blur="changeProjectDiscount"
                                        v-model="projectDiscount"></ui-input-field>
                        <span>{{projectDiscountSchema.project_discount_field.value}}</span>
                    </div>
                    <a v-if="projectMessages.countSale == ''" class="calculate-discont-hide" v-on:click="discountForm()">{{projectMessages.countSale}}</a>
                    <a v-else class="calculate-discont" v-on:click="discountForm()">{{projectMessages.countSale}}</a>
                  <p class="transfer">
                    <label for="transfer"> {{projectMessages.transfer}}
                      <input :checked="projectTransferSchema.project_transfer_field.checked" id="transfer" type="checkbox" v-on:input="changeTransferCheckbox($event)">
                    </label>
                  </p>
                  </div>
                </template>
            </div>
        </div>
        <div v-if="projectMessages" class="bottom-container">
            <div class="links-wrap">
                <a href="javascript:void(0)">
                    <span v-on:click="downloadPdf"><i class="demo-icon icon-upload"></i>
                    {{projectMessages.downloadPdf}}
                    </span>
                    <select class="format">
                        <option value="PDF">PDF</option>
                        <option value="XLSX">XLSX</option>
                    </select>
                </a>
                <a v-if="!sendMail" href="javascript:void(0)" v-on:click="sendPdf">
                    <i class="demo-icon icon-mail"></i>
                    {{projectMessages.sendPdf}}
                </a>
                <a v-else href="javascript:void(0)">
                    <i class="demo-icon icon-mail"></i>
                    {{projectMessages.sentPdf}}
                </a>
                <a href="javascript:void(0)" v-on:click="printPdf">
                    <i class="demo-icon icon-print"></i>
                    {{projectMessages.printPdf}}
                </a>
            </div>
            <div class="btns">
                <a href="javascript:void(0)" v-on:click="addProjectToBasket" class="btn-std btn">
                    {{projectMessages.projectToBasket}}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import ProjectDetailItem from "vueComponents/project/ProjectDetailItem";
    import ProjectName from "vueComponents/project/ProjectName";
    import uiInputField from "vueComponents/ui-elements/fields/Input";

    /**
     * Контейнер для отображения содержимого проекта.
     *
     *  - projectItems информация о товарах в проекте
     *  - projectTotalSum стоимость товаров в проекте
     *  - projectMessages статический текст для отображение в проекте выдаваемый бэком в зависемости от языка
     *   <project-item> - конкретный товар в проекте
     * @vuedoc
     * @module vue:containers/Project
     * @exports vue:containers/Project
     */
    export default {
        name: "project-detail",

        props: ['project_id', 'language', 'selfslct'],

        data() {
            return {
                selfSelect: true,
                photoSelect: true,
                discountOpen: false,
                selecte: '',
                projectDiscount: "",
                projectNotes1: "",
                projectNotes2: "",
                projectNotes3: "",
                sendMail: false,
            }
        },

        components: {
            'project-detail-item': ProjectDetailItem,
            'project-name': ProjectName,
            'ui-input-field': uiInputField,
        },

        computed: {

            ...mapGetters('project', [
                'projectItems', 'projectSelfSchema', 'projectTotalSum', 'projectMessages', 'projectDiscountSchema','projectTransferSchema', 'projectNotesSchema'
            ]),

            /**
             *  Вычисляемое свойство возвращает товары в проекте
             *
             * @method getProjectItems
             */
            getProjectItems: function () {
                if (this.projectItems) {
                    return this.projectItems;
                }
                return false;
            },

            /**
             *  Вычисляемое свойство возвражает общую стоимость товаров в проекте
             *
             * @method getProjectTotalSum
             */
            getProjectTotalSum: function () {
                if (this.projectTotalSum) {
                    return this.projectTotalSum;
                }
                return false;
            },
        },

        mounted() {
            this.selecte = this.selfslct;
            if (this.project_id)
                this.$store.dispatch('project/getItems', {
                    projectId: this.project_id,
                    selfSelect: this.selfSelect,
                    photoSelect: this.photoSelect
                });
            else
                console.log("no project name");
            this.$store.dispatch('project/getProjectDiscountSchema', this.project_id);
            this.$store.dispatch('project/getProjectTransferSchema', this.project_id);
            this.$store.dispatch('project/getProjectNotesSchema', this.project_id);
            this.$store.dispatch('project/getProjectSelfSchema', this.project_id);

        },
        methods: {
            changeSelfSelect() {
                this.selfSelect = this.selecte;
                this.$store.dispatch('project/getItems', {
                    projectId: this.project_id,
                    selfSelect: this.selfSelect,
                    photoSelect: this.photoSelect
                });
              // this.$store.dispatch('project/getProjectTransferSchema', this.project_id);
            },
          /**
           *  Изменяет метод оплаты для проекта
           *
           * @method changeTransferCheckbox
           */
          changeTransferCheckbox($event = false) {
            this.$store.dispatch('project/changeProjectTransfer', {
              "projectId": this.project_id,
              selfSelect: this.selfSelect,
              photoSelect: this.photoSelect,
              "newProjectTransfer": $event.target.checked
            });
          },
            changePhotoSelect() {
                if (this.photoSelect)
                    this.photoSelect = false;
                else
                    this.photoSelect = true;
                this.$store.dispatch('project/getItems', {
                    projectId: this.project_id,
                    selfSelect: this.selfSelect,
                    photoSelect: this.photoSelect
                });
            },
            discountForm() {
                if (this.discountOpen)
                    this.discountOpen = false;
                else
                    this.discountOpen = true;
                this.$store.dispatch('project/getItems', {
                    projectId: this.project_id,
                    selfSelect: this.selfSelect,
                    photoSelect: this.photoSelect
                });
            },

            /**
             *  Изменяет скидку для проекта
             *
             * @method changeProjectDiscount
             */
            changeProjectDiscount() {
                if (this.projectDiscount) {
                    this.$store.dispatch('project/changeProjectDiscount', {
                        "projectId": this.project_id,
                        "newProjectDiscount": this.projectDiscount
                    });
                }
            },

            /**
             *  Изменяет записки для проекта
             *
             * @method changeProjectNotes
             */
            changeProjectNotes1() {
                if (this.projectNotes1) {
                    this.projectNotes2 = this.projectNotes2 ? this.projectNotes2 : this.projectNotesSchema.project_notes2_field.value;
                    this.projectNotes3 = this.projectNotes3 ? this.projectNotes3 : this.projectNotesSchema.project_notes3_field.value;
                    this.$store.dispatch('project/changeProjectNotes', {
                        "projectId": this.project_id,
                        "newProjectNotes1": this.projectNotes1,
                        "newProjectNotes2": this.projectNotes2,
                        "newProjectNotes3": this.projectNotes3,
                    });
                }
            },

            /**
             *  Изменяет записки для проекта
             *
             * @method changeProjectNotes
             */
            changeProjectNotes2() {
                if (this.projectNotes2) {
                    this.projectNotes1 = this.projectNotes1 ? this.projectNotes1 : this.projectNotesSchema.project_notes1_field.value;
                    this.projectNotes3 = this.projectNotes3 ? this.projectNotes3 : this.projectNotesSchema.project_notes3_field.value;
                    this.$store.dispatch('project/changeProjectNotes', {
                        "projectId": this.project_id,
                        "newProjectNotes1": this.projectNotes1,
                        "newProjectNotes2": this.projectNotes2,
                        "newProjectNotes3": this.projectNotes3,
                    });
                }
            },

            /**
             *  Изменяет записки для проекта
             *
             * @method changeProjectNotes
             */
            changeProjectNotes3() {
                if (this.projectNotes3) {
                    this.projectNotes1 = this.projectNotes1 ? this.projectNotes1 : this.projectNotesSchema.project_notes1_field.value;
                    this.projectNotes2 = this.projectNotes2 ? this.projectNotes2 : this.projectNotesSchema.project_notes2_field.value;
                    this.$store.dispatch('project/changeProjectNotes', {
                        "projectId": this.project_id,
                        "newProjectNotes1": this.projectNotes1,
                        "newProjectNotes2": this.projectNotes2,
                        "newProjectNotes3": this.projectNotes3,
                    });
                }
            },

            addProjectToBasket() {
                this.$store.dispatch('project/addProjectToBasket', {
                    "projectItems": JSON.stringify(this.projectItems),
                });
            },

            downloadPdf() {
                let format = $('.format').find(":selected").val();
                const formData = new FormData();
                formData.append('projectId', this.project_id);
                formData.append("handler", "projects");
                if (format == 'PDF') {
                    formData.append("func", "downloadPdf");
                }else if (format == 'XLSX') {
                    formData.append("func", "downloadXlsx");
                }
                formData.append("selfSelect", this.selfSelect);
                formData.append("photoSelect", this.photoSelect);
                formData.append("lang", this.language);

                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data' // for POST requests
                axios.post('/ajax/common.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    if (format == 'PDF') {
                        window.open(response.data, '_blank');
                    }else if (format == 'XLSX') {
                        const url = response.data.url;
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `${response.data.name}.xls`);
                        console.log(link);
                        document.body.appendChild(link);
                        link.click();
                    }
                })
                    .catch(err => {
                        console.error(err);
                    });
            },

            printPdf() {
                const formData = new FormData();
                formData.append('projectId', this.project_id);
                formData.append("handler", "projects");
                formData.append("func", "downloadPdf");
                formData.append("selfSelect", this.selfSelect);
                formData.append("photoSelect", this.photoSelect);

                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data' // for POST requests
                axios.post('/ajax/common.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    console.log("url->", response.data);
                    window.open('/personal/projects/printproject.php?file=' + response.data, '_blank');
                })
                    .catch(err => {
                        console.error(err);
                    });
            },

            sendPdf() {
                const formData = new FormData();
                formData.append('projectId', this.project_id);
                formData.append("handler", "projects");
                formData.append("func", "sendPdf");
                formData.append("selfSelect", this.selfSelect);
                formData.append("photoSelect", this.photoSelect);

                axios.defaults.headers.post['Content-Type'] = 'multipart/form-data' // for POST requests
                axios.post('/ajax/common.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.sendMail = true;
                    this.$store.dispatch('project/getProjectLogoSchema', this.project_id);
                })
                    .catch(err => {
                        console.error(err);
                    });
            },
            deleteProject(link) {
                event.preventDefault();
                this.link = link;
                this.$modal.show({
                        template: `
                                <def-modal-alert >
                                <div class="modal-vacancy-confirm__confirm">
                                    <span>${ this.projectMessages.deleteProjectAsk }</span>
                                    <button class="btn-std btn def-button" @click="$parent.$emit('check'); $emit('close')">${ this.projectMessages.deleteProject }</button>
                                </div>
                                </def-modal-alert>
                                `,
                        props: ['result', 'status'],
                    },
                    {
                        // text: response.text,
                        // status: response.status
                    },
                    {
                        adaptive: true,
                        width: 580,
                        height: 'auto',
                    }, {
                        'closed': this.close,
                        'check': this.check,
                    }
                );
            },
            close() {
                this.$emit('close');
            },
            check() {
                this.$store.dispatch('project/deleteProject', {
                    projectId: this.project_id,
                    link: this.link,
                });
            },
        }
    }


</script>

<style>
 .calculate-discont-hide {
   display: none;
 }
 .format {
     margin-left: 5px;
 }
</style>
